import styled from 'styled-components';

const ContentContainer = styled.div`
  width: 100%;
  margin-top: ${props => (props.theme.isMobile ? 64 : 80)}px;
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 64px;
  width: 100%;

  ${props => props.theme.isMobileOrTablet && `
    padding: 0 28px;
  `};

  ${props => props.theme.isMobile && `
    flex-direction: column;
    padding: 0 20px !important;
  `};
`;

const ShadedSectionContainer = styled(SectionContainer)`
  background-color: #f7fafc;
`;

const SectionTitle = styled.div`
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 28px;
  line-height: 120%;
  text-transform: uppercase;
  width: 33%;
  margin-right: 20px;

  ${props => !props.theme.isXLarge && `
    font-size: 24px;
  `};

  ${props => props.theme.isMobile && `
    border-bottom: 1px solid;
    border-color: #DBE1E8;
    margin-bottom: 40px;
    padding-bottom: 16px;
    width: 100%;
  `};

  > span {
    font-size: 28px;
    font-weight: ${props => props.theme.fontWeightBold};
  }
`;

const SectionSubTitle = styled.div`
  color: #627484;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightRegular};
  font-size: 19px;
  line-height: 120%;
  text-transform: none;
  margin-top: 16px;
  padding-bottom: 12px;

  ${props => props.theme.isMobileOrTablet && `
    font-size: 17px;
  `};

  ${props => props.theme.isMobile && `
    margin-top: 8px;
  `};
`;

const SectionDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 67%;

  ${props => props.theme.isMobile && `
    width: 100%;
  `};
`;

const TenTwentyFourCollapseSectionContainer = styled(ShadedSectionContainer)`
  width: auto;
  ${props => (props.theme.isXLarge ? `
    border-radius: 6px;
    margin-left: -60px;
    margin-right: -60px;
    padding: 0 60px;
    padding-top: 114px;
    padding-bottom: 144px;
  ` : `
    flex-direction: column;
    margin-left: -32px;
    margin-right: -32px;
    padding: 0 32px;
    padding-top: 80px;
    padding-bottom: 112px;

    ${props.theme.isMobileOrTablet && `
      width: 100%;
      margin: 0 0 64px;
      padding-top: 70px;
      padding-bottom: 130px;

      ${props.theme.isMobile && `
        padding-top: 56px !important;
        padding-bottom: 80px !important;
      `};
    `};

    & > ${SectionTitle} {
      margin-top: 40px;
      margin-bottom: 40px;
      padding-bottom: 16px;
      width: 100%;

      ${props.theme.isMobileOrTablet && `
        margin-top: 0px;
        border: none;
      `};
    }

    & > ${SectionDetails} {
      width: 100%;
    }
  `)};
`;

const Separator = styled.div`
  width: 100%;
  height: 0px;
  border: none;
  border-bottom: 1px solid #D7DFE7;
`;

const DesktopSeparator = styled(Separator)`
  ${props => props.theme.isMobile && `
    display: none;
  `};
`;

export {
  ContentContainer,
  DesktopSeparator,
  SectionContainer,
  ShadedSectionContainer,
  SectionTitle,
  SectionSubTitle,
  SectionDetails,
  Separator,
  TenTwentyFourCollapseSectionContainer,
};
